import { GlowingEffect } from "../ui/GlowingEffect";
import { counterItems } from "../../constants/index";
import { useStateContext } from "../../context/ContextProvider";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";

const Counter = () => {
  const { currentLang } = useStateContext();
  const{t}=useTranslation()
  return (
    <div className="flex flex-col justify-center items-center bg-gradient-to-b from-light-glass1 to-light-glass2 dark:from-dark-glass1 darl:to-dark-glass2   container  rounded-2xl border border-light-glass1 dark:border-dark-glass1 py-4">

      <div className="flex w-full items-start">
        <h2 className={`h4 mb-4 dark:text-dark-title text-light-blue`}>
         {t("Manafith by Figures")}
        </h2>
      </div>
      <ul className="grid grid-cols-2 md:grid-cols-6 gap-4 md:gap-5 w-full ">
        {counterItems.map((item, index) => (
          <GridItem
            key={index}
            title={currentLang === "ar" ? item.text_Ar : item.text_En}
            number={item.number}
          />
        ))}
      </ul>
    </div>
  );
};

const GridItem = ({ title, number }) => {
  return (
    <li className="flex transform transition-transform duration-300 hover:scale-105">

      <div className="relative h-full w-full rounded-xl border border-light-strock  dark:border-dark-strock p-2 md:rounded-2xl md:p-3">
        <GlowingEffect
             blur={0}
             borderWidth={2}
             spread={80}
             glow={true}
             disabled={false}
             proximity={64}
             inactiveZone={0.01}
        />

        <div className="relative flex flex-col h-full justify-center items-center gap-3 md:gap-4 overflow-hidden rounded-lg p-3 md:p-4  
        min-h-[80px] md:min-h-[100px]">
          <CountUp
            className="text-xl md:text-2xl font-bold dark:text-dark-title text-light-blue text-center"
            start={0}
            end={number}
            duration={3}
            useEasing={true}
            separator=","
          />
          <p className="body-2 text-center text-light-subtitle dark:text-dark-subtitle leading-tight px-1">
            {title}
          </p>
        </div>
      </div>
    </li>
  );
};

export default Counter;